import { wallet } from "../types";


export const addAmountToWallet = ({ orderAmount, securityDeposit = 0 , navigate , formName}) => ({
    type: wallet.ADD_AMOUNT_TO_WALLET_REQUEST,
    payload: { orderAmount, securityDeposit , navigate , formName}
})


export const getWalletDetails = ({ updateBalance = false }) => ({
    type: wallet.GET_WALLET_DETAILS_REQUEST,
    payload: { updateBalance }
})
